import type { NextPage } from "next";
import { useContext } from "react";
import { useSelector } from "react-redux";
import nextAuth from "../next-routes/next-auth";
import GenericSetHead from "../src/components/shared-components/GenericSetHead";
import { BrandContext } from "../src/contexts/BrandContext";
import { BrandState } from "../src/redux/reducers/brand.reducer";
import { brandSelector } from "../src/redux/selectors/app.selectors";
import wrapper from "../src/redux/store";
import LoginPageView from "../src/views/login/LoginPageView";

export const getServerSideProps = wrapper.getServerSideProps((store) =>
  nextAuth(store, undefined, {
    allowPublic: true,
  })
);

const Login: NextPage = () => {
  const { brand }: BrandState = useSelector(brandSelector);
  const { shareable_image_url, favicon_image_url } = useContext(BrandContext);

  if (!brand) {
    return null;
  }

  return (
    <>
      <GenericSetHead
        title={`Login ${brand?.title ? `to ${brand?.title}` : ""}`}
        siteName={brand?.title ?? "Login"}
        metadata={[
          {
            property: "image",
            content: shareable_image_url || "",
          },
          {
            property: "url",
            content: brand?.domain,
          },
          {
            property: "icon",
            content: favicon_image_url || "",
          },
        ]}
      />
      <LoginPageView />
    </>
  );
};

export default Login;
